/*

    <FormFile data={docs} setData={(o: any) => setDocs(o)} allowMultiple={true} />
    v1.1.2

    (c) radim.potesil@gmail.com

 */
import React, { useRef, useState } from "react";
import { imageExtensions } from "../../../enums/imageExtensions";
import { FormFileItem } from "./FormFileItem";
const extFileUpload = () => {
};
export const FormFile = (props) => {
    const fileInputRef = useRef(null);
    const mainImage = props.data.mainImage;
    const [dropdownOpen, setDropdown] = useState(false);
    const newFileUpload = () => {
        var fileList = [];
        if (props.data)
            fileList = [...props.data.list];
        let inputDom = fileInputRef.current;
        var fileCount = inputDom.files.length;
        var currentFileIndex = 0;
        function pushFile() {
            var file = inputDom.files[currentFileIndex];
            let ext = file.name.substr(file.name.lastIndexOf('.') + 1);
            if (imageExtensions.includes(ext.toLowerCase())) {
                let reader = new FileReader();
                reader.onloadend = () => {
                    fileList.push({
                        name: file.name,
                        ext: ext,
                        size: file.size,
                        type: 'image',
                        thumbData: reader.result,
                        fileDOM: file,
                        status: 'new'
                    });
                    currentFileIndex++;
                    if (currentFileIndex < fileCount)
                        pushFile();
                    else
                        finalize();
                };
                if (file)
                    reader.readAsDataURL(file);
            }
            else {
                fileList.push({
                    name: file.name,
                    ext: ext,
                    size: file.size,
                    type: 'document',
                    fileDOM: file,
                    status: 'new'
                });
                currentFileIndex++;
                if (currentFileIndex < fileCount)
                    pushFile();
                else
                    finalize();
            }
        }
        function finalize() {
            var newMainImage = mainImage;
            if (mainImage == -1 && fileList.length > 0)
                newMainImage = 0;
            props.setData({
                mainImage: newMainImage,
                list: fileList
            });
            inputDom.value = '';
        }
        pushFile();
    };
    const setMainImage = (newId) => {
        var newKey = 0;
        for (let i = 0; i < props.data.list.length; i++) {
            let item = Object.assign({}, props.data.list[i]);
            if (newId == item.id) {
                newKey = i;
            }
        }
        props.setData({
            mainImage: newKey,
            list: props.data.list
        });
    };
    const removeItem = (removeId) => {
        var newList = [];
        var newMainImage = mainImage; //comming from props
        for (let i = 0; i < props.data.list.length; i++) {
            let item = Object.assign({}, props.data.list[i]);
            if (item.status == 'new' && removeId == item.id) {
                //skip
            }
            else {
                if (removeId == item.id)
                    item.status = "removal";
                newList.push(item);
            }
            if (mainImage == i)
                newMainImage = -1; //if that was set as a mainImage, reset that
        }
        props.setData({
            mainImage: newMainImage,
            list: newList
        });
    };
    return (React.createElement("div", { className: "form-file" },
        React.createElement("div", { className: "input" },
            React.createElement("input", { multiple: props.allowMultiple, type: "file", ref: fileInputRef, onChange: newFileUpload, name: "newFile" })),
        React.createElement("div", { className: "list" }, props.data && props.data.list && props.data.list.map((item, key) => React.createElement(FormFileItem, { key: key, item: item, index: key, mainImage: mainImage, removeItem: (newKey) => removeItem(newKey), setMainImage: (newKey) => setMainImage(newKey), allowMainImage: props.allowMainImage })))));
};
